// components
import MultiLingual from "../Components/Multilingual/MultiLingual"
const MultiLingualPage = () => {
    return (
        <MultiLingual />
    )
}
export default MultiLingualPage;